import { FC, useEffect, useRef, useState } from 'react';

import { Box, Typography } from '@mui/material';

import { ReactComponent as GrowexaIcon } from 'assets/icons/GrowexaIcon.svg';

import { ModalComponent } from 'components/_basic/ModalComponent/ModalComponent';

import { IDocDownloadProgressModalProps as IProps } from './types';

import styles from './DocDownloadProgressModal.module.scss';

const workerScript = `
  self.onmessage = function (event) {
    const canvas = event.data.canvas;

    particle_no = 25;

    requestAnimFrame = (function() {
      return requestAnimationFrame ||
        webkitRequestAnimationFrame ||
        mozRequestAnimationFrame ||
        oRequestAnimationFrame ||
        msRequestAnimationFrame ||
        function(callback) {
          setTimeout(callback, 1000 / 60);
        };
    })();
    
    var ctx = canvas.getContext("2d");

    if (ctx) {
    
      var counter = 0;
      var particles = [];
      var w = 400,
        h = 30;
      canvas.width = w;
      canvas.height = h;
      
      function reset() {
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, w, h);
      
        ctx.fillStyle = "rgb(220,220,220)";
        ctx.beginPath();
        ctx.roundRect(25, 10, 350, 10, 20);
        ctx.fill();
      }
      
      function progressbar() {
        this.widths = 0;
        this.hue = 0;
      
        this.draw = function() {
          ctx.fillStyle = 'rgb(48, 143, 232)';
          ctx.beginPath();
          ctx.roundRect(25, 10, this.widths, 10, 20);
          ctx.fill();
        }
      }
      
      function particle() {
        this.x = 23 + bar.widths;
        this.y = 82;
      
        this.vx = 0.8 + Math.random() * 1;
        this.v = Math.random() * 5;
        this.g = 1 + Math.random() * 3;
        this.down = false;
      
        this.draw = function() {
          ctx.fillStyle = 'rgb(48, 143, 232)';
        }
      }
      
      bar = new progressbar();
      
      function draw() {
        reset();
        counter += 2;
      
        bar.hue += 0.8;
      
        bar.widths += 6;
        if (bar.widths > 350) {
          if (counter > 215) {
            reset();
            bar.hue = 0;
            bar.widths = 0;
            counter = 0;
            particles = [];
          } else {
            bar.hue = 126;
            bar.widths = 351;
            bar.draw();
          }
        } else {
          bar.draw();
          for (var i = 0; i < particle_no; i += 10) {
            particles.push(new particle());
          }
        }
        update();
      }
      
      function update() {
        for (var i = 0; i < particles.length; i++) {
          var p = particles[i];
          p.x -= p.vx;
          if (p.down == true) {
            p.g += 0.1;
            p.y += p.g;
          } else {
            if (p.g < 0) {
              p.down = true;
              p.g += 0.1;
              p.y += p.g;
            } else {
              p.y -= p.g;
              p.g -= 0.1;
            }
          }
          p.draw();
        }
      }
      
      function animloop() {
        draw();
        requestAnimFrame(animloop);
      }
      
      animloop();
    }
  };
`;

export const DocDownloadProgressModal: FC<IProps> = ({ isModalOpened, modalText }) => {
  const ref = useRef(null);
  const [, setUpdate] = useState(0);

  useEffect(() => {
    const canvas = ref.current;
    if(canvas) {
      const blob = new Blob([workerScript], { type: 'text/javascipt' });
      const worker = new Worker(window.URL.createObjectURL(blob));
      // @ts-expect-error no types
      const offscreenCanvas = canvas.transferControlToOffscreen();
      offscreenCanvas && worker.postMessage({ canvas: offscreenCanvas }, [offscreenCanvas]);

      return () => worker.terminate();
    } else {
      setTimeout(() => setUpdate((prev) => prev + 1), 100)
    }
  }, [ref.current])

  return (
    <ModalComponent open={isModalOpened}>
      <Box className={styles.downloadProgressModalWrapper}>
        <GrowexaIcon className={styles.logo} />
        <Typography className={styles.modalText} variant="body1">
          {modalText}
        </Typography>
        <canvas height={30} ref={ref}></canvas>
      </Box>
    </ModalComponent>
  );
};
